import { render, staticRenderFns } from "./generalRequestForm.vue?vue&type=template&id=2a042665&scoped=true"
import script from "./generalRequestForm.vue?vue&type=script&lang=js"
export * from "./generalRequestForm.vue?vue&type=script&lang=js"
import style0 from "./generalRequestForm.vue?vue&type=style&index=0&id=2a042665&prod&lang=scss"
import style1 from "./generalRequestForm.vue?vue&type=style&index=1&id=2a042665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a042665",
  null
  
)

export default component.exports